import { findBestMatchingNavRoute } from './nav-match';

const DEFAULT_PAGE_TITLE = 'Boards';

export function resolvePageTitle(pathname: string, override?: string): string {
  if (override) {
    return override;
  }

  return findBestMatchingNavRoute(pathname)?.pageTitle ?? DEFAULT_PAGE_TITLE;
}

export function isStandaloneTitleHidden(pathname: string): boolean {
  const route = findBestMatchingNavRoute(pathname);
  if (route?.hideStandaloneTitle) {
    return true;
  }

  // Preserve historical dashboard toolbar routes that hide the topbar title.
  return (
    pathname.startsWith('/board/views') ||
    pathname.startsWith('/board/custom-dashboard') ||
    pathname.startsWith('/board/attribution')
  );
}
